class OnLoad {

    constructor() {
        this.events();
    }

    events() {
        this.onPageLoad();
    }

    onPageLoad() {
        if (document.readyState === "loading") {
            document.addEventListener("DOMContentLoaded", () => this.onReady());
        } else {
            this.onReady();
        }

        // Mobile menu
        document.querySelectorAll('.menu-item-has-children > a').forEach(item => {
            item.addEventListener('click', e => {
                // mobile only
                if (window.innerWidth <= 600) {
                    e.preventDefault();
                    item.parentElement.classList.toggle('open');
                }
            });
        });

        // Language switcher set session storage parameter in order to reload page
        document.addEventListener("click", function (event) {
            const languageLink = event.target.closest(".lang-item a");

            if (!languageLink) {
                return;
            }

            sessionStorage.setItem("language_switch", "1");
        });

        // Wizard div
        const wizard = document.querySelector(".wizard-box-container");

        if (wizard) {
            this.makeDraggable(wizard);
        }

    }

    onReady() {
        const navigation = performance.getEntriesByType("navigation")[0];

        const isReload = navigation?.type === "reload";

        const isLanguageSwitch = sessionStorage.getItem("language_switch") === "1";

        if (!isReload && !isLanguageSwitch) {
            return;
        }

        const detailsLi = document.querySelector(
            ".primary-menu > li .horizontal-submenu-wrapper li.current-menu-parent.is_detail"
        ) || document.querySelector(
            ".primary-menu > li .horizontal-submenu-wrapper li.current-menu-item.is_detail"
        );

        if (detailsLi) {
            const listLi = document.querySelector(
                ".primary-menu > li .horizontal-submenu li:has(+ li.current-menu-parent)"
            ) || document.querySelector(
                ".primary-menu > li .horizontal-submenu li:has(+ li.current-menu-item)"
            );

            detailsLi.classList.remove("current-menu-item");
            listLi?.classList.add("current-menu-item");

            listLi?.querySelector("a")?.click();

            // Remove ONLY after the logic has executed
            sessionStorage.removeItem("language_switch");
        }
    }

    // MAKING A DIV DRAGGABLE
    makeDraggable(mydiv) {
        let pos3 = 0;
        let pos4 = 0;
        const dragMouseDown = (e) => {
            e.preventDefault();

            // Make sure we're controlling the element with top/left
            const rect = mydiv.getBoundingClientRect();

            // Convert its current position to top/left
            mydiv.style.left = `${rect.left + window.scrollX}px`;
            mydiv.style.top = `${rect.top + window.scrollY}px`;
            mydiv.style.bottom = "auto";

            pos3 = e.clientX;
            pos4 = e.clientY;

            document.addEventListener("mousemove", elementDrag);
            document.addEventListener("mouseup", closeDragElement, { once: true });
        };

        const elementDrag = (e) => {
            e.preventDefault();

            const dx = e.clientX - pos3;
            const dy = e.clientY - pos4;

            pos3 = e.clientX;
            pos4 = e.clientY;

            mydiv.style.left =
                `${mydiv.offsetLeft + dx}px`;

            mydiv.style.top =
                `${mydiv.offsetTop + dy}px`;
        };

        const closeDragElement = () => {
            document.removeEventListener("mousemove", elementDrag);
        };

        mydiv.addEventListener("mousedown", dragMouseDown);
    }
}

new OnLoad();